import { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Exception from '../../../components/Exception';
import Loading from '../../../components/Loading';
import { usePartnerConfig } from '../../../components/PartnerConfigProvider';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import withException from '../../../components/withException';
import paths from '../../../paths.json';

const Account = lazy(() => import('../Account'));
const CustomReport = lazy(() => import('../CustomReport'));
const ConversionReport = lazy(() => import('../ConversionReport'));
const Settings = lazy(() => import('../Settings'));
const Dashboard = lazy(() => import('../Dashboard'));
const Offers = lazy(() => import('../Offer'));
const Payments = lazy(() => import('../Payments'));
const Notifications = lazy(() => import('../Notifications'));
const Support = lazy(() => import('../Support'));

const HomeRoutes = () => {
  const settings = usePartnerConfig();

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Redirect exact from={paths.home} to={paths.dashboard} />
        <Route path={paths.account}>
          <Account />
        </Route>
        <Route path={paths.dashboard}>
          <Dashboard />
        </Route>
        <Route path={paths.offers}>
          <Offers />
        </Route>
        <Route path={paths.notifications}>
          <Notifications />
        </Route>
        <Route path={paths.payments}>
          <Payments />
        </Route>
        {settings.supportTicketsEnabled && (
          <Route path={paths.support}>
            <Support />
          </Route>
        )}
        {settings.conversionReportEnabled && (
          <Route path={paths.conversionReport}>
            <ConversionReport />
          </Route>
        )}
        <Route path={paths.customReport}>
          <CustomReport />
        </Route>
        <Route path={paths.settings}>
          <Settings />
        </Route>
        <Route>
          <Exception />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default withException(HomeRoutes);
